export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/pet_portrait.0cbe348.svg";